import * as React from "react";
const SvgArrowTopRight = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path d="M6.34291 4H11.9998M11.9998 4V9.65684M11.9998 4L4 12" stroke="white" strokeWidth={1.33} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgArrowTopRight;